import translationEN from './en/translation.json';
import translationFR from './fr/translation.json';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: translationEN
    },
    fr: {
        translation: translationFR
    }
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: ['en', 'fr'],
        fallbackLng: 'en',
        debug: false,
        react: {
            useSuspense: false,
        },
    });

export default i18n;